import {SlotGame} from "@nolimitcity/slot-game/bin/core/SlotGame";
import {IWinRatioConfig, WinRatioType} from "@nolimitcity/slot-game/bin/core/winpresentation/WinRatio";
import {TimelineLite} from "gsap";
import {TractorBeamSoundConfig} from "../TractorBeamSoundConfig";
import {TractorBeamGameConfig} from "../TractorBeamGameConfig";

export class SoundPlayer {

    private _countActive:boolean = true;
    private _currentMusic:string;

    constructor() {}

    public startCountUp() {
        SlotGame.sound.playEffect(TractorBeamSoundConfig.instance.COUNT_UP_LOOP, 2000);
        this._countActive = true;
    }

    public stopCountUp(shouldPlayStopSound:boolean = true) {
        SlotGame.sound.stopEffect(TractorBeamSoundConfig.instance.COUNT_UP_LOOP);
        if (shouldPlayStopSound && !TractorBeamGameConfig.instance.WIN_BELOW_STAKE) {  // #226
            SlotGame.sound.playEffect(TractorBeamSoundConfig.instance.COUNT_UP_END);
        }
        this._countActive = false;
    }

    public switchToFsMusic() {
        if(this._currentMusic == TractorBeamSoundConfig.instance.FREESPIN_AMBIANCE) {
            return;
        }
        const tl:TimelineLite = new TimelineLite();
        tl.add(() => SlotGame.sound.playAmbience(TractorBeamSoundConfig.instance.FREESPIN_AMBIANCE));
        this._currentMusic = TractorBeamSoundConfig.instance.FREESPIN_AMBIANCE;
    }

    public switchToMainMusic() {
        if(this._currentMusic == TractorBeamSoundConfig.instance.MAIN_GAME_AMBIANCE) {
            return;
        }
        const tl:TimelineLite = new TimelineLite();
        tl.add(() => SlotGame.sound.playAmbience(TractorBeamSoundConfig.instance.MAIN_GAME_AMBIANCE));
        this._currentMusic = TractorBeamSoundConfig.instance.MAIN_GAME_AMBIANCE;
    }


    public playNormalWinSound(winRatioConfig:IWinRatioConfig) {
        let soundName:string = "";
        switch(winRatioConfig.type) {
            case WinRatioType.TINY:
                soundName = TractorBeamSoundConfig.instance.WIN_TINY;
                break;
            case WinRatioType.SMALL:
                soundName = TractorBeamSoundConfig.instance.WIN_SMALL;
                break;
            case WinRatioType.MEDIUM:
                soundName = TractorBeamSoundConfig.instance.WIN_MEDIUM;
                break;
            case WinRatioType.LARGE:
                soundName = TractorBeamSoundConfig.instance.WIN_LARGE;
                break;
            default:
                soundName = "";
                break;
        }

        SlotGame.sound.playEffect(soundName);
    }
}
